import { spanFromRegExpMatch } from '../spans';
import type { ExtractorOutput } from './types';

const SQFT_TOKEN = '\\b(?:sq\\s*ft|sqft|square\\s+(?:feet|foot)|sf)\\b';

export function extractSqftRange(query: string): ExtractorOutput {
  const rangeMatch = query.match(new RegExp(`(\\d{3,5})\\s*(?:to|-)\\s*(\\d{3,5})\\s*${SQFT_TOKEN}`, 'i'));
  if (rangeMatch && rangeMatch.index !== undefined) {
    const sqftMin = parseInt(rangeMatch[1], 10);
    const sqftMax = parseInt(rangeMatch[2], 10);
    return {
      partial: { sqftMin, sqftMax },
      spans: [
        spanFromRegExpMatch(query, rangeMatch, 'sqft', { sqftMin, sqftMax }, {
          confidence: 0.95,
          ruleId: 'sqft.range',
        }),
      ],
    };
  }

  const overMatch = query.match(
    new RegExp(`(?:over|above|at\\s+least|more\\s+than|min(?:imum)?)\\s+(\\d{3,5})\\s*${SQFT_TOKEN}`, 'i')
  );
  if (overMatch && overMatch.index !== undefined) {
    const sqftMin = parseInt(overMatch[1], 10);
    return {
      partial: { sqftMin },
      spans: [
        spanFromRegExpMatch(query, overMatch, 'sqftMin', sqftMin, {
          confidence: 0.95,
          ruleId: 'sqft.min',
        }),
      ],
    };
  }

  const underMatch = query.match(
    new RegExp(`(?:under|below|less\\s+than|max(?:imum)?|up\\s+to)\\s+(\\d{3,5})\\s*${SQFT_TOKEN}`, 'i')
  );
  if (underMatch && underMatch.index !== undefined) {
    const sqftMax = parseInt(underMatch[1], 10);
    return {
      partial: { sqftMax },
      spans: [
        spanFromRegExpMatch(query, underMatch, 'sqftMax', sqftMax, {
          confidence: 0.95,
          ruleId: 'sqft.max',
        }),
      ],
    };
  }

  const plainMatch = query.match(new RegExp(`(\\d{3,5})\\+?\\s*${SQFT_TOKEN}`, 'i'));
  if (plainMatch && plainMatch.index !== undefined) {
    const sqftMin = parseInt(plainMatch[1], 10);
    return {
      partial: { sqftMin },
      spans: [
        spanFromRegExpMatch(query, plainMatch, 'sqftMin', sqftMin, {
          confidence: 0.9,
          ruleId: 'sqft.plain-min',
        }),
      ],
    };
  }

  return { partial: {}, spans: [] };
}
